import { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    q: '査定は無料ですか？',
    a: 'はい、AI査定・訪問査定ともに完全無料です。査定後に売却を強制することは一切ありません。',
  },
  {
    q: '近所に知られずに売却できますか？',
    a: 'はい、可能です。買取の場合は広告掲載なしで進められるため、ご近所への告知は不要です。秘密厳守を徹底しています。',
  },
  {
    q: '相続した不動産でも相談できますか？',
    a: 'もちろんです。相続登記が未完了の状態でもご相談いただけます。手続きの流れも丁寧にご説明します。',
  },
  {
    q: '名古屋以外の物件でも対応できますか？',
    a: '全国からのご相談を承っています。ただし、特に名古屋市内16区は地元ネットワークを活かした対応が可能です。',
  },
  {
    q: '売却をキャンセルすることはできますか？',
    a: '契約前であれば、いつでもキャンセル可能です。相談・査定の段階でのキャンセルは費用も一切かかりません。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#4A90E2] text-sm font-medium tracking-widest mb-3 uppercase">FAQ</p>
          <h2 className="text-[#1A2B4A] text-2xl md:text-4xl font-bold">よくあるご質問</h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-100 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-[#F8F9FB] transition-colors duration-200"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-[#1A2B4A] font-medium text-sm md:text-base pr-4">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`text-[#4A90E2] text-lg transition-transform duration-200 ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`} />
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 text-[#4A90E2] text-sm font-medium hover:underline cursor-pointer"
          >
            すべてのFAQを見る
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
